














import Enumerable from "linq";
import { Mixins, Component, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import ReceptionDialogSelector from "../../selectors/ReceptionDialogSelector.vue";
import { ProjectTeam } from "../../../../domain/projectTeam";
import ProjectTeamListSelectorDialog from "../../../department/dialogs/ProjectTeamListSelectorDialog.vue";
import { ReceptionDetail, ReceptionManager } from "../../../../domain/workflow/reception";

@Component({
  components: {
    ReceptionDialogSelector,
  }
})
export default class ReceptionDetailProjectTeamEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  projectTeamSelectDialog: ProjectTeamListSelectorDialog;

  @Prop()
  isDepartmentEnable: boolean;

  @Prop()
  isManagerEnable: boolean;

  @Prop()
  shouldAutoApplyProjectTeamInfo: boolean;

  projectTeamSelector: ReceptionDialogSelector;
  
  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.projectTeamSelector = this.$refs.projectTeamSelector as ReceptionDialogSelector;
  }

  get projectTeam(): ProjectTeam {
    return this.readPropertyOrDefault(d => d.projectTeam, null);
  }

  set projectTeam(value: ProjectTeam) {
    this.writeProperty((d: ReceptionDetail) => {
      d.projectTeam = value;
      // 入力単位が受付単位のものは連動入力しない
      if (this.shouldAutoApplyProjectTeamInfo && this.isDepartmentEnable && value && value.department) { d.department = value.department; }
      if (this.shouldAutoApplyProjectTeamInfo && this.isManagerEnable && value && value.members) {
        d.managers = Enumerable.from(value.members)
          .select((m, index) => new ReceptionManager(index + 1, m.user)).toArray();
      }
    });
  }

  selectProjectTeam(): void {
    this.projectTeamSelector.select();
  }
}
